import React, { Component } from 'react'
import classnames from 'classnames'
import qs from 'qs'
import { withRouter } from 'react-router-dom'
import Summary from './EnrolmentGuide/Summary'
import CoursePattern from './EnrolmentGuide/CoursePattern'
import Loading from './Loading'
import { getEnrolmentGuide } from '../../services/vu'
import { getCourseId } from '../../helpers/course'
import { getAttributeCourseStaticInfo } from '../../helpers/enrolment'

class EnrolmentGuide extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loadingEnrolmentGuide: true,
      enrolmentGuideOpen: false,
      enrolmentGuideCoursePatterOpen: false,
      availabilityYear: null,
      enrolmentGuides: new Map(),
      studyPeriodCodes: [],
      studyPackages: []
    }
  }

  componentDidMount() {
    if (this.props.setEnrolmentGuideLoading) {
      this.props.setEnrolmentGuideLoading(true)
    }
    getEnrolmentGuide(getAttributeCourseStaticInfo('courseSSPNo'), this.props.availabilityYear)
      .then(studyPackages => {
        this.setEnrolmentGuideProperties(studyPackages)
        let enrolmentGuides = this.state.enrolmentGuides;
        if (studyPackages) {
          enrolmentGuides.set(studyPackages[0].unitAvailabilityYear, studyPackages)
        }
        this.setState({
          enrolmentGuides: enrolmentGuides,
          studyPackages: studyPackages,
          loadingEnrolmentGuide: false
        })
      })
      .catch(reason => {
        this.setEnrolmentGuideProperties([])
        this.setState({
          studyPackages: [],
          loadingEnrolmentGuide: false
        })
      })
  }

  componentDidUpdate(prevProps, prevState) {
    if ((prevProps.availabilityYear !== this.props.availabilityYear
          && !this.state.enrolmentGuides.has(parseInt(this.props.availabilityYear)))
          || this.props.reloadEnrolmentGuide) {
      if (this.state.enrolmentGuideOpen) {
        this.setState({
          availabilityYear: null,
          studyPeriodCodes: [],
          enrolmentGuideCoursePatterOpen: false,
          enrolmentGuideOpen: false
        })
      }
      if (this.props.setEnrolmentGuideLoading) {
        this.props.setEnrolmentGuideLoading(true)
      }
      this.setState({
        loadingEnrolmentGuide: true
      })
      getEnrolmentGuide(getAttributeCourseStaticInfo('courseSSPNo'), this.props.availabilityYear)
        .then(studyPackages => {
          this.setEnrolmentGuideProperties(studyPackages)

          let enrolmentGuides = this.state.enrolmentGuides;
          if (studyPackages) {
            enrolmentGuides.set(studyPackages[0].unitAvailabilityYear, studyPackages)
          }

          this.setState({
            enrolmentGuides: enrolmentGuides,
            studyPackages: studyPackages,
            loadingEnrolmentGuide: false
          })
        })
        .catch(reason => {
          this.setEnrolmentGuideProperties([])
          this.setState({
            studyPackages: [],
            loadingEnrolmentGuide: false
          })
        })
  } else if ((prevProps.availabilityYear !== this.props.availabilityYear
          && this.state.enrolmentGuides.has(parseInt(this.props.availabilityYear)))) {
        let studyPackages = this.state.enrolmentGuides.get(parseInt(this.props.availabilityYear));

        this.setEnrolmentGuideProperties(studyPackages)
        this.setState({
            studyPackages: studyPackages,
            loadingEnrolmentGuide: false
          })
    }
  }

  setEnrolmentGuideProperties = studyPackages => {
    if (this.props.setEnrolmentGuideStudyPackages) {
      this.props.setEnrolmentGuideStudyPackages(studyPackages)
    }
    if (this.props.setEnrolmentGuideLoading) {
      this.props.setEnrolmentGuideLoading(false)
    }
  }

  handleButtonClick = () => {
    this.setState({
      enrolmentGuideOpen: !this.state.enrolmentGuideOpen
    })
  }

  isEnrolmentGuideOpen = () => {
    return this.state.enrolmentGuideOpen
  }

  isEnrollingForFirstTime = () => {
    let enrollingForFirstTime = false
    if (this.props.location && this.props.location.state && this.props.location.state.enrollingForFirstTime) {
      enrollingForFirstTime = this.props.location.state.enrollingForFirstTime
    }

    const isEnrollingForTheFirstTime = this.props.enrollingForFirstTime || (enrollingForFirstTime && enrollingForFirstTime === 'true')
    return isEnrollingForTheFirstTime
  }

  isTeachingPeriodSelected = () => {
    return this.state.enrolmentGuideCoursePatterOpen
  }

  setAvailabilityYearAndStudyPeriods = (availabilityYear, studyPeriodCodes = []) => {
    this.setState({
      availabilityYear: availabilityYear,
      studyPeriodCodes: studyPeriodCodes,
      enrolmentGuideCoursePatterOpen: true
    })
  }

  courseBackButtonClicked = () => {
    this.setState({
      availabilityYear: null,
      studyPeriodCodes: [],
      enrolmentGuideCoursePatterOpen: false
    })
  }

  render() {
    //    if (!hasCoursePatterns(this.props.hasCoursePatternsFlag)) {
    //      return null
    //    }

    return (
      <aside
        className={classnames('enrolment-guide', {
          'enrolment-guide--active': this.isEnrolmentGuideOpen()
        })}
      >
        <button type="button" className="enrolment-guide__button" onClick={this.handleButtonClick}>
          Unit enrolment guide
        </button>

        {this.state.loadingEnrolmentGuide ? (
          <div className="enrolment-guide__content-container">
            <Loading />
          </div>
        ) : (
          <div
            className={classnames('enrolment-guide__content-container', {
              'enrolment-guide__content-container--active': this.isTeachingPeriodSelected()
            })}
          >
            {/*
                IF advanced standing student, pathways student OR NOT enrolling for the first time
                THEN show dynamic content (based on course-pattern)
                ELSE show static content
                SHFL-59 - Continuing student with hasCoursePattern = 'P' will see dynamic content
              */
            //removed the prefill call
            //  this.props.prefillAdvancedStanding ||
            this.props.hasCoursePatternsFlag === 'P' ||
            //  this.props.prefillPathwayStudent ||
            !this.isEnrollingForFirstTime() ? (
              <div>
                <Summary
                  studyPackages={this.state.studyPackages}
                  focusable={this.isEnrolmentGuideOpen() && !this.isTeachingPeriodSelected()}
                  prefillAttemptSuccessful={this.props.prefillAttemptSuccessful}
                  setAvailabilityYearAndStudyPeriods={this.setAvailabilityYearAndStudyPeriods}
                  courseYear={this.props.courseYear}
                  strictPattern={this.props.strictPattern}
                  unitsAcrossMultipleYears={this.props.unitsAcrossMultipleYears}
                  firstPass={this.props.firstPass}
                  secondPass={this.props.secondPass}
                  enrollingAcademicYear={this.props.enrollingAcademicYear}
                />

                <CoursePattern
                  studyPackages={this.state.studyPackages}
                  availabilityYear={this.state.availabilityYear}
                  studyPeriodCodes={this.state.studyPeriodCodes}
                  courseBackButtonClicked={this.courseBackButtonClicked}
                  focusable={this.isEnrolmentGuideOpen() && this.isTeachingPeriodSelected()}
                />
              </div>
            ) : (
              <div className="enrolment-guide__content enrolment-guide__content--summary">
                <h1>Enrolment guide</h1>
                <p>
                  Your enrolment has been pre-filled with prescribed units to ensure you have met all of the requirements of your course and pattern of study.
                  <br />
                  Amendments to unit offerings can only be made after you have submitted your enrolment.
                  <br />
                  If you have any questions please contact{' '}
                  <a href="https://www.vu.edu.au/contact-us/vuhq-student-service-centres" target="_blank">
                    <strong>VUHQ</strong>
                  </a>{' '}
                </p>
              </div>
            )}
          </div>
        )}
      </aside>
    )
  }
}

export default withRouter(EnrolmentGuide)
